<template>
  <div class="w-100">
    <div v-if="isLoading" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <div v-if="generalError" class="py-3">
        <ErrorMessage :message="generalError" />
      </div>
      <template v-else>
        <!-- MAP VIEW -->
        <template v-if="viewType === 'map'">
          <div class="w-100 position-relative">
            <div class="w-100" :key="map.keyUpdate">
              <gmap-map
                v-if="$isNotEmptyV2(map.center)"
                :center="map.center" 
                :options="map.config"
                :zoom="15" 
                style="width:100%;  
                height: 300px;"
                @center_changed="handleMapCenterChange">
                <gmap-marker :position="map.marker"></gmap-marker>
              </gmap-map>
            </div>
            <div class="my-location" id="current-location" @click="getCurrentLocation">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="my_location_24px">
              <path id="icon/maps/my_location_24px" fill-rule="evenodd" clip-rule="evenodd" d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12Z" class="fill-primary"/>
              </g>
              </svg>
            </div>
            <b-tooltip v-if="!map.gpsPermission.allowed" target="current-location" placement="top" title="Please allow permission to access your location">
            </b-tooltip>
          </div>
          <div class="w-100 p-4">
            <div class="d-flex justify-content-between mb-3 align-items-center">
              <p class="mb-0 body-1-4">Full Address</p>
              <button class="g-btn g-btn-secondary g-btn-sm px-4 " @click="toggleViewType('search')">Find</button>
            </div>
            <div class="p-3 radius-12 bg-white box-shadow-light-aff border-form mb-4">
              <p class="mb-0 body-2-4 mb-1">Address Detail</p>
              <p class="mb-0 body-2-2 mb-4">{{ map.result }}</p>
              <div class="d-flex radius-12 border-form p-3 justify-content-between" :class="{'border-danger': $v.otherForm.landmark.$error}">
                <div class="align-items-center lh-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="directions_24px">
                      <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                        d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                        class="fill-primary" />
                    </g>
                  </svg>
                </div>
                <input class="border-0 no-focus-border align-items-center w-90 body-2-2" v-model="otherForm.landmark" placeholder="Add landmark">
              </div>
              <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="$v.otherForm.landmark.$error">Please give some detail</p>
            </div>
            
            <div v-if="!addressOnly" class="p-3 radius-12 bg-white box-shadow-light-aff border-form">
              <div class="w-100 mb-3">
                <label class="body-3 mb-1 d-block">Saved as</label>
                <input 
                  type="text" 
                  class="p-2-5 body-2-1 w-100 border-form radius-6" 
                  :class="{'border-danger': $v.otherForm.title.$error}"
                  v-model="otherForm.title" >
                <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="$v.otherForm.title.$error">Please input address name</p>
              </div>
              <div class="w-100 mb-3">
                <label class="body-3 mb-1 d-block">Recipient name</label>
                <input 
                  type="text" 
                  class="p-2-5 body-2-1 w-100 border-form radius-6" 
                  :class="{'border-danger': $v.otherForm.receiver_name.$error}"
                  v-model="otherForm.receiver_name" >
                <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="$v.otherForm.receiver_name.$error">Please input recipient name</p>
              </div>
              <div class="w-100">
                <label class="body-3 mb-1 d-block">Recipient phone number (optional)</label>
                <input 
                  type="text" 
                  class="p-2-5 body-2-1 w-100 border-form radius-6" 
                  v-model="otherForm.phone" >
              </div>
            </div>
          </div>
        </template>

        <!-- SEARCH LOCATION VIEW -->
        <template v-else>
          <div class="w-100 px-4 pt-4 border-t-form" style="height: 50vh;overflow-y: auto;">
            <div class="w-100 mb-4 pb-4 border-b-form-dashed-2">
              <div class="w-100 mb-3 border-form radius-6 p-3 d-flex justify-content-between">
                <input ref="input_find_location" type="text" class="border-0 align-items-center no-focus-border w-90 body-2-1" placeholder="Search location" v-model="search.keyword">
                <div v-if="search.keyword != ''" class="align-items-center lh-1" @click="search.keyword = ''">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_587_22)">
                      <path
                        d="M0.228308 13.7716C0.537114 14.0717 1.04885 14.0717 1.34883 13.7716L6.99557 8.12491L12.6423 13.7716C12.9423 14.0717 13.4629 14.0805 13.7628 13.7716C14.0628 13.4629 14.0628 12.9599 13.7628 12.66L8.1161 7.0044L13.7628 1.35766C14.0628 1.05767 14.0717 0.545937 13.7628 0.245954C13.454 -0.0628521 12.9423 -0.0628521 12.6423 0.245954L6.99557 5.8927L1.34883 0.245954C1.04885 -0.0628521 0.528291 -0.0716751 0.228308 0.245954C-0.0716751 0.55476 -0.0716751 1.05767 0.228308 1.35766L5.87505 7.0044L0.228308 12.66C-0.0716751 12.9599 -0.0804984 13.4717 0.228308 13.7716Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_587_22">
                        <rect width="13.9911" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <button class="g-btn g-btn-secondary-outline g-btn-sm px-4 align-items-center" @click="toggleViewType('map')">Select via map</button>
            </div>
            <div class="w-100">
              <div v-if="search.isLoading" class="py-4 text-center">
                <loader/>
              </div>
              <template v-else>
                <div class="w-100">
                  <ErrorMessage v-if="search.error != ''" :message="search.error" />
                  <template v-else>
                    <div class="w-100 mb-3 pb-3 border-b-form" v-for="place in search.result" @click="selectPlace(place.location.lat, place.location.lng)">
                      <p class="body-2-4 mb-0">{{ place.name }}</p>
                      <p class="body-3 mb-0">{{ place.formatted_address }}</p>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { post, get } from "@/services/index.js";
  import { validationMixin } from "vuelidate";
  const { required } = require("vuelidate/lib/validators");

  export default {
    props:{
      defaultData:{
        type: Object,
        default: () => {} // { latitude: 0, longitude: 0, landmark: '', title: '', receiver_name: '', phone: '' }
      },
      addressOnly:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        viewType: 'map',
        isLoading: true,
        generalError: "",
        map:{
          config: {
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            gestureHandling: 'greedy'
          },
          center: {},
          marker: {},
          keyUpdate: 0,
          debounceTimer: null,
          result: "",
          city: "",
          gpsPermission:{
            allowed: false,
            support: true
          }
        },
        search:{
          isLoading: false,
          error: '',
          result: [],
          keyword: "",
          debounceTimer: null
        },
        otherForm:{
          landmark: '',
          title: '',
          receiver_name: '',
          phone: ''
        },
        otherFormError:{ 
          landmark: '',
          title: '',
          receiver_name: ''
        }
      }
    },
    mixins: [validationMixin],
    validations: {
      otherForm:{
        landmark:{ required },
        title: { required },
        receiver_name:{ required }
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      searchLocationKeyword(){
        return this.search.keyword;
      },
    },
    watch:{
      searchLocationKeyword(){
        if(this.viewType === 'search'){
          this.findPlace()
        }
      }
    },
    mounted(){
      this.setupData()
    },
    methods:{
      toggleShowFooter(show){
        this.$emit('show-footer', show)
      },
      toggleNoCloseBackdropForm(show){
        this.$emit('no-close-backdrop', show)
      },
      async setupData(){
        try {
          this.toggleShowFooter(false)
          this.isLoading = true;
          await this.loadDataFromProps();
          this.$v.$reset();
        } catch (error) { 
          this.generalError = `Error: Something went wrong. Please try again later. Detail : ${error.message}`
        } finally {
          this.isLoading = false;
          this.toggleShowFooter(true);
        }
      },
      async loadDataFromProps(){
        try {
          const { latitude = null, longitude = null, address = '', title = '', receiver_name = '', phone = '' } = this.defaultData;

          const isPositionValid = this.$isNotEmptyV2(latitude) || this.$isNotEmptyV2(longitude);
          const validPosition = isPositionValid ? { latitude, longitude } : await this.getCurrentLocationApi();
          await this.setDetailMapPosition(validPosition.latitude, validPosition.longitude)
          this.otherForm = { landmark: address, title, receiver_name, phone }
          
        } catch (error) {
          throw error;
        }
      },
      async setDetailMapPosition(lat, lng){
        try {
          this.map.center = { lat, lng }
          this.map.marker = { lat, lng }
          this.map.keyUpdate++

          const detailLocation = await this.getDetailLocation(lat, lng);
          this.map.result = detailLocation.parsedAddress
          this.map.city = detailLocation.city
        } catch (error) {
          throw error;
        }
      },
      async getDetailLocation(lat,long){
        try {
          const apiResponse = await get("CORE", "user-location", { lat, long });
          const { success, message, data } =  apiResponse.data

          if(!success) throw new Error(message);

          const getCity = () => {
            const components = data.address_components || [];
            const cityComponent = components.find(comp => comp.types.includes("administrative_area_level_2"));
            return cityComponent ? cityComponent.long_name : "";
          };
          
          return {
            parsedAddress: data.formatted_address,
            city: getCity()
          };
        } catch (error) {
          throw error;
        }
      },
      getCurrentLocationApi(){
        return new Promise((resolve, reject) => {
          const defaultLocation = {
            latitude: this.getMerchant.lat,
            longitude: this.getMerchant.lng,
          }
          
          if(!navigator.geolocation){
            self.map.gpsPermission.support = false;
            resolve(defaultLocation);
          };

          const self = this;
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords; 
              self.map.gpsPermission = {
                allowed : true,
                support: false
              }
              resolve({ latitude, longitude });
            },
            (error) => {
              if(error.code === error.PERMISSION_DENIED) self.map.gpsPermission.allowed = false
              else self.map.gpsPermission.support = false;
              resolve(defaultLocation);
            },
            {
              enableHighAccuracy: true, // Get precise GPS location
              maximumAge: 0             // Always fetch fresh location
            }
          );
        });
      },
      async getCurrentLocation(){
        try {
          if(!this.map.gpsPermission.allowed) return;
          
          const { latitude, longitude } = await this.getCurrentLocationApi();
          await this.setDetailMapPosition(latitude, longitude);
        } catch (error) {
          console.log("ERROR setDetailMapPosition(): ", error.message);
        }
      },
      handleMapCenterChange(newPosition){
        const { lat, lng } = { lat: newPosition.lat(), lng: newPosition.lng() };
        this.map.marker = {lat, lng}
        if (this.map.debounceTimer) {
          clearTimeout(this.map.debounceTimer);
        }

        this.map.debounceTimer = setTimeout(async () => {
          try {
            const detailLocation = await this.getDetailLocation(lat, lng);
            this.map.result = detailLocation.parsedAddress
            this.map.city = detailLocation.city   
          } catch (error) {
            console.log("ERROR handleMapCenterChange(): ", error.message);
          }
        }, 500);
      },
      toggleViewType(newViewType){
        this.viewType = newViewType
        this.toggleShowFooter(newViewType === 'map')
      },
      findPlace(){
        if (this.search.debounceTimer) {
          clearTimeout(this.search.debounceTimer);
        }

        this.search.debounceTimer = setTimeout(() => {
          if(this.search.keyword != ''){
            this.getPlaceFromGmaps() 
          }
        }, 500);
      },
      selectPlace(latitude, longitude){
        this.toggleViewType('map')
        this.setDetailMapPosition(latitude, longitude);
      },
      async getPlaceFromGmaps(){
        try {
          this.search.isLoading = true
          this.search.error = ""
          this.search.result = []

          const responseApi = await get("CORE_HOTEL", "maps-search", {
            text_search: this.search.keyword
          })
          const { success, data, message } =  responseApi.data
          if(!success) throw new Error(message);
          this.search.result = data;
          
        } catch (error) {
          this.search.error = error.message 
        } finally {
          this.search.isLoading = false
        }
      },
      async submitForm(){
        try {
          if(this.addressOnly){
            this.$v.otherForm.landmark.$touch();
            if (this.$v.otherForm.landmark.$error) return;
          }else{
            this.$v.$touch();
            if (this.$v.$error) return;
          }
          
          const { lat, lng } = this.map.marker
          
          if(this.addressOnly){
            return {
              latitude: lat,
              longitude: lng,
              landmark: this.otherForm.landmark
            }
          }
          return {
            latitude: lat,
            longitude: lng,
            city: this.map.city,
            ...this.otherForm
          }

        } catch (error) {
          throw error;
        }
      }
    }
  }
</script>
<style>
.my-location{
  position: absolute; 
  bottom: 18px;
  right: 18px;
  height: 45px;
  width: 45px;
  display: grid;
  place-items: center;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ccc;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/general/SetupAddress.vue